import React from 'react';
import Head from 'next/head';
import Link from 'next/link';
import { i18n, withNamespaces } from '../i18n';

const Terms = ({ t }) => {
	return (
		<div>
			<Head>
				<title>CollectAPI - {t('terms')}</title>
			</Head>

			<div className="container">
				<div className="row mt-5">
					<div className="col">
						<blockquote>
							<h4>COLLECTAPİ.COM TERMS OF SERVICE</h4>
						</blockquote>
						<p>
							Last Updated: <b>07.03.2017</b>
						</p>
						<p>These terms of service ("Terms") apply to your access and use of collectapi.com. Please read them carefully.</p>
						<blockquote>
							<h4>Accepting these Terms</h4>
						</blockquote>
						<p>
							If you access or use the Service, it means you agree to be bound by all of the terms below. So, before you use the Service, please read all of the terms. If you don't agree to all of the
							terms below, please do not use the Service. Also, if a term does not make sense to you, please let us know by e-mailing{' '}
							<a href="mailto:info@collectapi.com?Subject=Collect%20API%20Terms" target="_top">
								info@collectapi.com
							</a>
							.
						</p>
						<blockquote>
							<h4>Changes to these Terms</h4>
						</blockquote>
						<p>We reserve the right to modify these Terms at any time. For instance, we may need to change these Terms if we come out with a new feature or for some other reason.</p>
						<p>
							Whenever we make changes to these Terms, the changes are effective 3 month after we post such revised Terms (indicated by revising the date at the top of these Terms) or upon your
							acceptance if we provide a mechanism for your immediate acceptance of the revised Terms (such as a click-through confirmation or acceptance button). It is your responsibility to check
							collectapi.com for changes to these Terms.
						</p>
						<p>If you continue to use the Service after the revised Terms go into effect, then you have accepted the changes to these Terms.</p>
						<blockquote>
							<h4>Privacy Policy</h4>
						</blockquote>
						<p>
							For information about how we collect and use information about users of the Service, please check out our privacy policy available at{' '}
							<Link href="/privacy">
								<a>collectapi.com PRIVACY POLICY</a>
							</Link>
							.
						</p>
						<blockquote>
							<h4>Third-Party Services</h4>
						</blockquote>
						<p>
							From time to time, we may provide you with links to third party websites or services that we do not own or control. Your use of the Service may also include the use of applications that
							are developed or owned by a third party. Your use of such third party applications, websites, and services is governed by that party's own terms of service or privacy policies. We
							encourage you to read the terms and conditions and privacy policy of any third party application, website or service that you visit or use.
						</p>
						<blockquote>
							<h4>Creating Accounts</h4>
						</blockquote>
						<p>
							When you create an account or use another service to log in to the Service, you agree to maintain the security of your password and accept all risks of unauthorized access to any data or
							other information you provide to the Service.
						</p>
						<p>If you discover or suspect any Service security breaches, please let us know as soon as possible.</p>
						<blockquote>
							<h4>Your Content & Conduct</h4>
						</blockquote>
						<p>
							Our Service allows you and other users to post, link and otherwise make available content. You are responsible for the content that you make available to the Service, including its
							legality, reliability, and appropriateness.
						</p>
						<p>
							When you post, link or otherwise make available content to the Service, you grant us the right and license to use, reproduce, modify, publicly perform, publicly display and distribute
							your content on or through the Service. We may format your content for display throughout the Service, but we will not edit or revise the substance of your content itself.
						</p>
						<p>Aside from our limited right to your content, you retain all of your rights to the content you post, link and otherwise make available on or through the Service.</p>
						<p>
							You can remove the content that you posted by deleting it. Once you delete your content, it will not appear on the Service, but copies of your deleted content may remain in our system or
							backups for some period of time. We will retain web server access logs for a maximum of 5 year and then delete them.
						</p>
						<p>You may not post, link and otherwise make available on or through the Service any of the following:</p>
						<ul>
							<li>Content that is libelous, defamatory, bigoted, fraudulent or deceptive;</li>
							<li>Content that is illegal or unlawful, that would otherwise create liability;</li>
							<li>Content that may infringe or violate any patent, trademark, trade secret, copyright, right of privacy, right of publicity or other intellectual or other right of any party;</li>
							<li>Mass or repeated promotions, political campaigning or commercial messages directed at users who do not follow you (SPAM);</li>
							<li>Private information of any third party (e.g., addresses, phone numbers, email addresses, Social Security numbers and credit card numbers); and</li>
							<li>Viruses, corrupted data or other harmful, disruptive or destructive files or code.</li>
						</ul>
						<p>Also, you agree that you will not do any of the following in connection with the Service or other users:</p>
						<ul>
							<li>
								Use the Service in any manner that could interfere with, disrupt, negatively affect or inhibit other users from fully enjoying the Service or that could damage, disable, overburden or
								impair the functioning of the Service;
							</li>
							<li>Impersonate or post on behalf of any person or entity or otherwise misrepresent your affiliation with a person or entity;</li>
							<li>Collect any personal information about other users, or intimidate, threaten, stalk or otherwise harass other users of the Service;</li>
							<li>Create an account or post any content if you are not over 13 years of age years of age; and</li>
							<li>Circumvent or attempt to circumvent any filtering, security measures, rate limits or other features designed to protect the Service, users of the Service, or third parties.</li>
						</ul>
						<blockquote>
							<h4>Collectapi.com Materials</h4>
						</blockquote>
						<p>
							We put a lot of effort into creating the Service including, the logo and all designs, text, graphics, pictures, information and other content (excluding your content). This property is
							owned by us or our licensors and it is protected by U.S. and international copyright laws. We grant you the right to use it.
						</p>
						<p>
							However, unless we expressly state otherwise, your rights do not include: (i) publicly performing or publicly displaying the Service; (ii) modifying or otherwise making any derivative
							uses of the Service or any portion thereof; (iii) using any data mining, robots or similar data gathering or extraction methods; (iv) downloading (other than page caching) of any portion
							of the Service or any information contained therein; (v) reverse engineering or accessing the Service in order to build a competitive product or service; or (vi) using the Service other
							than for its intended purposes. If you do any of this stuff, we may terminate your use of the Service.
						</p>
						<blockquote>
							<h4>Hyperlinks and Third Party Content</h4>
						</blockquote>
						<p>
							You may create a hyperlink to the Service. But, you may not use, frame or utilize framing techniques to enclose any of our trademarks, logos or other proprietary information without our
							express written consent. <b>collectapi.com</b> makes no claim or representation regarding, and accepts no responsibility for third party websites accessible by hyperlink from the Service
							or websites linking to the Service. When you leave the Service, you should be aware that these Terms and our policies no longer govern. If there is any content on the Service from you
							and others, we don't review, verify or authenticate it, and it may include inaccuracies or false information. We make no representations, warranties, or guarantees relating to the
							quality, suitability, truth, accuracy or completeness of any content contained in the Service. You acknowledge sole responsibility for and assume all risk arising from your use of or
							reliance on any content.
						</p>
						<blockquote>
							<h4>Unavoidable Legal Stuff</h4>
						</blockquote>
						<p>
							THE SERVICE AND ANY OTHER SERVICE AND CONTENT INCLUDED ON OR OTHERWISE MADE AVAILABLE TO YOU THROUGH THE SERVICE ARE PROVIDED TO YOU ON AN AS IS OR AS AVAILABLE BASIS WITHOUT ANY
							REPRESENTATIONS OR WARRANTIES OF ANY KIND. WE DISCLAIM ANY AND ALL WARRANTIES AND REPRESENTATIONS (EXPRESS OR IMPLIED, ORAL OR WRITTEN) WITH RESPECT TO THE SERVICE AND CONTENT INCLUDED
							ON OR OTHERWISE MADE AVAILABLE TO YOU THROUGH THE SERVICE WHETHER ALLEGED TO ARISE BY OPERATION OF LAW, BY REASON OF CUSTOM OR USAGE IN THE TRADE, BY COURSE OF DEALING OR OTHERWISE. IN
							NO EVENT WILL <b>collectapi.com</b> BE LIABLE TO YOU OR ANY THIRD PARTY FOR ANY SPECIAL, INDIRECT, INCIDENTAL, EXEMPLARY OR CONSEQUENTIAL DAMAGES OF ANY KIND ARISING OUT OF OR IN
							CONNECTION WITH THE SERVICE OR ANY OTHER SERVICE AND/OR CONTENT INCLUDED ON OR OTHERWISE MADE AVAILABLE TO YOU THROUGH THE SERVICE, REGARDLESS OF THE FORM OF ACTION, WHETHER IN CONTRACT,
							TORT, STRICT LIABILITY OR OTHERWISE, EVEN IF WE HAVE BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES OR ARE AWARE OF THE POSSIBILITY OF SUCH DAMAGES. OUR TOTAL LIABILITY FOR ALL CAUSES
							OF ACTION AND UNDER ALL THEORIES OF LIABILITY WILL BE LIMITED TO THE AMOUNT YOU PAID TO <b>collectapi.com</b>. THIS SECTION WILL BE GIVEN FULL EFFECT EVEN IF ANY REMEDY SPECIFIED IN THIS
							AGREEMENT IS DEEMED TO HAVE FAILED OF ITS ESSENTIAL PURPOSE. You agree to defend, indemnify and hold us harmless from and against any and all costs, damages, liabilities, and expenses
							(including attorneys' fees, costs, penalties, interest and disbursements) we incur in relation to, arising from, or for the purpose of avoiding, any claim or demand from a third party
							relating to your use of the Service or the use of the Service by any person using your account, including any claim that your use of the Service violates any applicable law or
							regulation, or the rights of any third party, and/or your violation of these Terms.
						</p>
						<blockquote>
							<h4>Copyright Complaints</h4>
						</blockquote>
						<p>
							We take intellectual property rights seriously. In accordance with the Digital Millennium Copyright Act ("DMCA") and other applicable law, we have adopted a policy of terminating, in
							appropriate circumstances and, at our sole discretion, access to the service for users who are deemed to be repeat infringers.
						</p>
						<blockquote>
							<h4>Termination</h4>
						</blockquote>
						<p> If you breach any of these Terms, we have the right to suspend or disable your access to or use of the Service.</p>
						<blockquote>
							<h4>Entire Agreement</h4>
						</blockquote>
						These Terms constitute the entire agreement between you and <b>collectapi.com</b> regarding the use of the Service, superseding any prior agreements between you and <b>collectapi.com </b>
						relating to your use of the Service.
						<blockquote>
							<h4>Feedback</h4>
						</blockquote>
						<p>
							Please let us know what you think of the Service, these Terms and, in general, collectapi.com. When you provide us with any feedback, comments or suggestions about the Service, these
							Terms and, in general, collectapi.com, you irrevocably assign to us all of your right, title and interest in and to your feedback, comments and suggestions.
						</p>
						<blockquote>
							<h4>Questions & Contact Information</h4>
						</blockquote>
						<p>
							Questions or comments about the Service may be directed to us at the email address{' '}
							<a href="mailto:info@collectapi.com?Subject=Collect%20API%20Terms" target="_top">
								info@collectapi.com
							</a>
							.
						</p>
					</div>
				</div>
			</div>
		</div>
	);
};
Terms.getInitialProps = async () => {
	return { namespacesRequired: ['common'] };
};

export default withNamespaces()(Terms);
